import PropTypes from 'prop-types'
import { CreditCard } from '@phosphor-icons/react'

export const BankCardAddIcon = () => (
  <img src="/images/bank-card-add.svg" alt="" width={20} height={20} />
)

export const StripeIcon = () => (
  <img src="/images/stripe-icon.png" alt="Stripe" className="saved-method-summary__brand-icon" />
)

const BRAND_ICON_SRC = {
  amex: '/images/amex-card.svg',
  diners: '/images/diners-card.svg',
  discover: '/images/discover-card.svg',
  jcb: '/images/jcb-card.svg',
  mastercard: '/images/mastercard-card.svg',
  unionpay: '/images/unionpay-card.svg',
  visa: '/images/visa-card.svg',
}

export const CardBrandIcon = ({ brand }) => {
  const src = BRAND_ICON_SRC[brand?.toLowerCase()]
  return src ? (
    <img src={src} alt={brand} className="saved-method-summary__brand-icon" />
  ) : (
    <CreditCard className="saved-method-summary__icon" />
  )
}

CardBrandIcon.propTypes = {
  brand: PropTypes.string,
}
